export const DEFAULT_QUOTE_CURRENCY = 'USD';
export const DEFAULT_BASE_CURRENCY = null;

export const QUOTE_CURRENCIES = [
  { key: 'USD', text: 'USD', value: 'USD' },
  { key: 'USDC', text: 'USDC', value: 'USDC' },
  { key: 'EST', text: 'EST', value: 'EST' },
];
